<template>
    <section v-if="blok.reviewsBlock.content" id="customerReviews" class="reviews-section airport-page-section">
        <div class="reviews-section__container">
            <h2 class="reviews-section__title airport-page-title">
                {{ blok.reviewsBlock.content.title }}
            </h2>
            <div class="reviews-section__descr">
                <RichText :richtext="blok.reviewsBlock.content.description" />
            </div>
            <div class="reviews-section__carousel">
                <div id="feefo-service-review-carousel-widgetId" class="feefo-review-carousel-widget-service" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { IL4CustomerReviews } from '~/types';

defineProps<{ blok: { type: IL4CustomerReviews; default: null } }>();
const { url } = useFeefo();
useHead({
    script: [
        {
            src: url,
            type: 'text/javascript',
            defer: true,
            key: 'feefo-script-carousel',
        },
    ],
});
</script>

<style lang="postcss" scoped>
.reviews-section {
    &__container {
        @apply md:container;
    }
    &__descr {
        @apply mb-6 md:text-xl;
        :deep(p) {
            @apply text-xl;
        }
    }
    &__carousel {
        @apply md:-m-5 overflow-hidden;
    }
}
</style>
